import Img from 'src/components/shared/Img'

import { resolveContentfulImageSrc } from 'src/common/resolveContentfulImageSrc'
import Rating from '../../Rating'
import Typography from '../../Typography'
import { numberFormat } from 'src/common/utils'

import ButtonLink from 'src/components/shared/ButtonLink'

const ReviewWrapper = ({ link, onClick, children }) => (
  <>
    {link && (
      <ButtonLink
        href={link}
        className="relative mt-1 text-center"
        onClick={onClick}
        target="blank"
      >
        {children}
      </ButtonLink>
    )}
    {!link && <div className="mt-1 text-center">{children}</div>}
  </>
)

const DynamicMarkers = ({
  id,
  image,
  alt,
  rating,
  totalReviews,
  totalStars,
  color,
  link,
  onClick,
}) => {
  const imageSrc = resolveContentfulImageSrc(image)
  const logoHeight = id?.toLowerCase() === 'bbb' ? 80 : 25
  const logoWidth = id?.toLowerCase() === 'bbb' ? 160 : 142

  return (
    <div className="flex w-full flex-col items-center">
      {imageSrc ? (
        <Img
          src={imageSrc}
          alt={alt}
          layout="intrinsic"
          width={logoWidth}
          height={logoHeight}
          className="shrink-0"
          quality={90}
          imgStyle={{
            height: logoHeight,
            maxWidth: '100%',
            width: 'auto',
          }}
        />
      ) : (
        <div
          aria-hidden
          style={{
            height: logoHeight,
            maxWidth: '100%',
            width: 'auto',
          }}
        />
      )}
      {id?.toLowerCase() !== 'bbb' && (
        <>
          <Rating
            rating={rating}
            totalStars={totalStars}
            totalReviews={totalReviews}
            filledStarColor={color}
          />
          <ReviewWrapper link={link} onClick={onClick}>
            <Typography component="span" variant="bodySmallBold">
              {rating.toFixed(1)} |{' '}
            </Typography>
            {link && (
              <strong className="hover:underline">
                <Typography component="span" variant="bodySmallBold">
                  {numberFormat(totalReviews)}
                  {'+ '}
                </Typography>
                <Typography component="span" variant="bodySmall">
                  reviews
                </Typography>
              </strong>
            )}
            {!link && (
              <>
                <Typography component="span" variant="bodySmallBold">
                  {numberFormat(totalReviews)}
                  {'+ '}
                </Typography>
                <Typography component="span" variant="bodySmall">
                  reviews
                </Typography>
              </>
            )}
          </ReviewWrapper>
        </>
      )}
    </div>
  )
}

export default DynamicMarkers
